import React from 'react'
import './Graph.css'
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    ResponsiveContainer
  } from "recharts";

function Graph(props) {

    const {graphData} = props

    let graph = graphData[0]
    let attribute = graphData[1]

    let analysis = graphData[2]
    let brief = analysis.Brief
    let emotions = analysis.Emotions
    let remember = `analysis.Remember\!\!`


    const data = [
        {
          name: Object.keys(graph)[0],
          pv: graph[Object.keys(graph)[0]],
        },
        {
          name: Object.keys(graph)[1],
          pv: graph[Object.keys(graph)[1]],
        },
        {
          name: Object.keys(graph)[2],
          pv: graph[Object.keys(graph)[2]],
        },
        {
          name: Object.keys(graph)[3],
          pv: graph[Object.keys(graph)[3]],
        }
      ];


  return (
      <div className='result-container'>

        <u><h3 className='result'>RESULT</h3></u>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
            top: 5,
            bottom: 5
        }}
        >
        <XAxis dataKey="name" />
        <YAxis />
        <Bar dataKey="pv" fill="#8884d8" />
        </BarChart>
    </ResponsiveContainer>



    <div style={{textAlign:'left'}}>

        <div className='attribute'>{attribute}</div>

        <div className='report-points-container'>
            <div className='report-points'>BRIEF</div>
            <div className='text'>
                {
                    brief.map(item => {
                        return (
                            <p>{item}</p>
                        )
                    })
                }
            </div>
        </div>


        <div className='report-points-container'>
            <div className='report-points'>EMOTIONS</div>
            <ul className='text'>
                {
                    emotions.map(item => {
                        return (
                            <li>{item}</li>
                        )
                    })
                }
            </ul>
        </div>


        {/* <div>
            <div className='report-points'>REMEMBER</div>
            <ul>
            {
                remember.map(item => {
                    return (
                        <li>{item}</li>
                    )
                })
            }
            </ul>
        </div> */}

    </div>

    </div>
  )
}

export default Graph